// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3cvf1","col":"styles_col__3es07"};